import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { RequestType } from "../models/request-types.model";

@Injectable({
  providedIn: "root",
})
export class RequestTypesService {
  private readonly requestTypesUrl = "requestTypes";
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.requestTypesUrl;
  }

  getPolicyRequestTypesWithReasons(policyId: Guid): Observable<RequestType[]> {
    const params = new HttpParams().set("policyId", policyId.toString());
    // TODO: Vérifier si le endpoint est correct avec le back mergé du lot 1.1
    return this.http.get<RequestType[]>(`${this.baseUrl}/me/policy/${policyId}`, { params });
  }

  getQuotationRequestTypesWithReasons(quotationId: Guid): Observable<RequestType[]> {
    const params = new HttpParams().set("quotationId", quotationId.toString());

    return this.http.get<RequestType[]>(`${this.baseUrl}/me/quotation/${quotationId}`, { params });
  }
}
